import { render, staticRenderFns } from "./QuestionFields.vue?vue&type=template&id=4c3eff47&"
import script from "./QuestionFields.vue?vue&type=script&lang=js&"
export * from "./QuestionFields.vue?vue&type=script&lang=js&"
import style0 from "./QuestionFields.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports